<template>
  <span>
    <!-- <i
      class="el-icon-download"
      style="font-size:25px;margin-right:10px; cursor: pointer"
      title="导出Excel"
      @click="installExcel"
    ></i> -->
    <el-button type="primary" icon="el-icon-download" @click="installExcel"
                style="padding: 10px 20px"
      >导出Excel</el-button
    >
  </span>
</template>
<script>
export default {
  name: "excel",
  data() {
    return {};
  },
  props: {
    title: String,
    data: Array,
    fields: Array,
  },
  created() {},
  activated() {},
  mounted() {},
  watch: {},
  components: {},
  methods: {
    installExcel() {
      const selectedRows = this.data;

      const column = this.fields;

      this.excelExport({
        fileName: this.title,
        suffix: "csv",
        titles: column.map((item) => item.title),
        column: column,
        dataSource: selectedRows,
      });
    },
    excelExport({
      dataSource = [],
      titles = [],
      fileName = "data",
      column = [],
      suffix = "csv",
    }) {
      var dataType = "\uFEFF"; //解决乱码问题
      dataType += titles.join(","); //添加表格的头
      dataType += "\n"; // 以上是导出的Excel文件头部
      for (let i = 0; i < dataSource.length; i++) {
        for (let j = 0; j < column.length; j++) {
          dataType += `${
            dataSource[i][column[j].field] ? `${dataSource[i][column[j].field]}` : ""
          },`;
        }
        dataType += `,\n`;
      }
      const csvData = new Blob([dataType], {
        type: "text/csv",
      });
      const _a = document.createElement("a");
      _a.href = URL.createObjectURL(csvData);
      _a.target = "_blank";
      _a.download = `${fileName}.${suffix}`;
      document.body.appendChild(_a);
      _a.click();
      document.body.removeChild(_a);
    },
  },
};
</script>
<style lang="scss">
</style>
